import React from "react";
import { useTranslation } from "react-i18next";
import { useDatabase } from "./DatabaseContext";

const DatabaseHeader: React.FC = () => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const { folders, selectedFolderId } = useDatabase();

    const folderNameById = (id: string) => {
        const folder = folders.find((f) => f.id === id);
        return folder ? folder.name : "";
    };

    const title = selectedFolderId
        ? `${t("knowledgeLibrary")} › ${folderNameById(selectedFolderId)}`
        : t("knowledgeLibrary");

    return (
        <div className="dbPageHead">
            <h1>{title}</h1>
            <p>{t("databaseManageFilesSubtitle")}</p>
        </div>
    );
};

export default DatabaseHeader;
